const Loading = () => {
	return <h1>Laster</h1>;
};

export default Loading;